import { Column, Conditional, Else, If, Row, useSync } from "@hex-insights/core";
import { InternalLink, useActivePageRegistration } from "@hex-insights/router";
import {
	CalendarEventComponents,
	Icon,
	Tile,
	useCalendarEventDetailQuery,
	useRecordViewOnMount,
} from "@s-i-s-i/see-learning.shared";
import { Main } from "../../../../Components";
import { homePageInfo } from "../../../Home/pageinfo";
import { calendarEventHubDetailPageInfo } from "./pageinfo";

export function CalendarEventHubDetailPage() {
	const { calendarEventID } = calendarEventHubDetailPageInfo.useParams();
	useRecordViewOnMount(calendarEventID);

	const { loading, data, error } = useCalendarEventDetailQuery({ variables: { id: calendarEventID } });
	const calendarEvent = data?.calendarEvent;
	useActivePageRegistration(
		calendarEventHubDetailPageInfo,
		!!calendarEvent ? calendarEventHubDetailPageInfo.title(calendarEvent) : "",
	);

	const { syncID: rsvpSyncID, synchronize: synchronizeRSVP } = useSync();

	return (
		<Main>
			<Conditional>
				<If condition={loading}>Loading...</If>
				<If condition={error !== undefined}>Error loading calendar event</If>
				<Else>
					{!!calendarEvent && (
						<Column align="center">
							<Column
								justify="spaced-start"
								style={{
									width: "50rem",
									maxWidth: "var(--modal--large---max-width)",
								}}
							>
								<InternalLink to={homePageInfo.to} className="link--primary link--no-text-decoration">
									<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
										<Icon.ArrowLeft size={16} /> Back to Home
									</Row>
								</InternalLink>

								<Tile style={{ minHeight: "45rem" }}>
									<Tile.Body>
										<CalendarEventComponents.CalendarEventDetailDisplay
											calendarEvent={calendarEvent}
											withICalDownload
											withRSVPForm
											rsvpSyncID={rsvpSyncID}
											synchronizeRSVP={synchronizeRSVP}
										/>
									</Tile.Body>
								</Tile>
							</Column>
						</Column>
					)}
				</Else>
			</Conditional>
		</Main>
	);
}
